fragment PageRuleFragment on PageRule {
    id
    actionType
    isFieldBased
    targetPage {
        id
        position
    }
    enumElement {
        id
        name
    }
    field {
        id
    }
}
